import { Box, Grid, lighten, Typography, useTheme } from '@material-ui/core';
import React from 'react';
import { DomainGq } from '../../../../../graphql/projects/models/DomainGq';
import { DomainTypeGq } from '../../../../../graphql/projects/models/DomainTypeGq';
import { DomainPerformanceAnalysisGq } from '../../../../../graphql/projects/queries/analysis/useGetCompetitivePerformanceGq';
import { formatPercent } from '../../../../../logic/otherUtilities/formatting/formatPercent';
import { ColorPalette } from '../../../Palette/ColorPalette';
import { AnalysisFilterState } from '../../../Filter/analysisFilterState';
import VoxelText from '../../../../../components/voxel/Text/VoxelText';

export interface ItemAnalysis {
  domain: DomainGq;
  domainAnalysis?: DomainPerformanceAnalysisGq;
}

export interface ItemProps {
  Icon: React.ComponentType<any>;
  title: string;
  description: string;
  data: ItemAnalysis[];
  getValue: (analysis: ItemAnalysis) => number;
  getFormattedValue: (analysis: ItemAnalysis) => string;
  analysisFilterState: AnalysisFilterState;
  palette: ColorPalette;
}

export const Item: React.FC<ItemProps> = ({
  Icon,
  title,
  description,
  data,
  getValue,
  getFormattedValue,
  analysisFilterState,
  palette,
}) => {
  const theme = useTheme();

  return (
    <div>
      <div className="flex flex-row items-start gap-3 h-24">
        <Icon
          style={{ fontSize: 36, backgroundcolor: lighten(theme.palette.primary.light, 0.1) }}
        />
        <div>
          <VoxelText variant="page subtitle">{title}</VoxelText>
          <VoxelText>{description}</VoxelText>
        </div>
      </div>
      <Grid item xs={12}>
        {data.map((domainAnalysis) => {
          let backgroundColor = '#FFFFFF';
          if (domainAnalysis.domain.type === DomainTypeGq.PROJECT)
            backgroundColor = palette.secondaryScale[1];
          if (
            domainAnalysis.domain.type === DomainTypeGq.COMPETITOR ||
            (domainAnalysis.domain.type === DomainTypeGq.AUTOMATIC &&
              !analysisFilterState?.competitorColor)
          )
            backgroundColor = palette.primaryScale[2];
          if (
            domainAnalysis.domain.type === DomainTypeGq.AUTOMATIC &&
            !!analysisFilterState?.competitorColor
          )
            backgroundColor = palette.primaryScale[1];

          const width = Math.min(1, getValue(domainAnalysis) / 100);
          return (
            <div className="py-2 flex flex-col" key={domainAnalysis.domain.id}>
              <div className="flex flex-row items-center">
                <div className="text-sm font-normal truncate flex-grow">
                  {domainAnalysis.domain.name}
                  {domainAnalysis.domain.type === DomainTypeGq.PROJECT && ' (client)'}
                </div>
                <div className="ml-2 text-base font-medium truncate">
                  {getFormattedValue(domainAnalysis)}
                </div>
              </div>
              <div className="pt-[2.5px]">
                <div className="h-3.5 w-full bg-gray-100 rounded-full">
                  <div
                    className="h-3.5 rounded-full"
                    style={{
                      backgroundColor: backgroundColor,
                      width: formatPercent(width, 0) + '%',
                    }}
                  />
                </div>
              </div>
            </div>
          );
        })}
      </Grid>
    </div>
  );
};

export default Item;
